import { FieldConfig } from "../Components/Form/FormComponent/types";

export const getUserFields: FieldConfig[] = [
  { name: "displayName", label: "Display Name", type: "text", required: true },
  { name: "firstName", label: "First Name", type: "text", required: true },
  { name: "lastName", label: "Last Name", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  {
    name: "password",
    label: "Password",
    type: "password",
    required: true,
    showTogglePassword: true,
  },
  {
    name: "confirmPassword",
    label: "Confirm Password",
    type: "password",
    required: true,
    showTogglePassword: true,
  },
  {
    name: "role",
    label: "Role",
    type: "select",
    options: [
      "super admin",
      "admin",
      "Branch Manager",
      "sales",
      "content editor",
      "part-time sales",
      "IT",
    ],
    required: true,
  },
  {
    name: "branch",
    label: "Branch",
    type: "select",
    options: ["KD", "Kuantan"],
    required: true,
  },
];

export const getProfileFields: FieldConfig[] = [
  { name: "displayName", label: "Display Name", type: "text", disabled: true },
  { label: "First Name", name: "firstName", type: "text", disabled: true },
  { label: "Last Name", name: "lastName", type: "text", disabled: true },
  { label: "Email", name: "email", type: "email", disabled: true },
  { label: "Role", name: "role", type: "text", disabled: true },
  { label: "Branch", name: "branch", type: "text", disabled: true },
];
